import { useEffect, useState } from 'react';
import { type Toast, subscribeToasts } from './notificationBus';

export default function NotificationToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    return subscribeToasts((t) => setToasts((prev) => [...prev, t]));
  }, []);

  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((t) =>
      setTimeout(() => {
        setToasts((prev) => prev.filter((x) => x.id !== t.id));
      }, 3000),
    );
    return () => { timers.forEach(clearTimeout); };
  }, [toasts]);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed inset-x-0 top-4 z-[70] flex flex-col items-center gap-2 px-4 pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          className="flex items-center gap-2.5 px-4 py-3 rounded-2xl shadow-lg backdrop-blur-sm animate-slide-in pointer-events-auto"
          style={{ background: 'rgba(30,30,30,0.88)' }}
        >
          {t.type === 'success' && (
            <i className="ri-checkbox-circle-fill text-green-400 text-lg" />
          )}
          {t.type === 'info' && (
            <i className="ri-information-fill text-purple-400 text-lg" />
          )}
          {t.type === 'warn' && (
            <i className="ri-error-warning-fill text-amber-400 text-lg" />
          )}
          <div>
            <p className="text-sm font-semibold text-white">{t.title}</p>
            <p className="text-xs text-gray-300 mt-0.5">{t.message}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
